import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class HmlValidationService {

  constructor(@Inject(HttpClient) private readonly http: HttpClient) {
  }

  validateHmlFile(fileId: string): Promise<string> {
    let url = `/upload/file/validate/${fileId}/hml`;
    return firstValueFrom(this.http.post(url, {}))
      .then(resp => resp.toString())
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
